import React = require("react");
import * as i18next from 'i18next'
import { DependencyData, FieldData, StepData } from "../../../form/types";
import moment from "moment"
import { Answer } from "../../../../generated_models";

export let getStep4Data = (): StepData[] => {

    let fieldName = () => {
        let fieldId: number = 11
        let fieldName: FieldData = {
            field: {
                Id: fieldId, CreatedDate: moment(), Kind: "Text", itemOrderNumber: 1, description: "", optionalDefaultValue: "",
                title: i18next.t('Tab4.Name'), width_percentage: "Extra small", placeholder: "", label: 'Tab4.Name'
            },
            maybe_answers: [],
            maybe_labels: [],
            user_input: undefined
        }
        return fieldName
    }
    let f1 = fieldName()

    let fieldPrefix = () => {
        let fieldId: number = 12
        let fieldPrefix: FieldData = {
            field: {
                Id: fieldId, CreatedDate: moment(), Kind: "Text", itemOrderNumber: 2, description: "", optionalDefaultValue: "",
                title: i18next.t('Tab4.Prefix'), width_percentage: "Extra small", placeholder: "", label: 'Tab4.Prefix'
            },
            maybe_answers: [],
            maybe_labels: [],
            user_input: undefined
        }
        return fieldPrefix
    }
    let f2 = fieldPrefix()

    let fieldSurname = () => {
        let fieldId: number = 13
        let fieldSurname: FieldData = {
            field: {
                Id: fieldId, CreatedDate: moment(), Kind: "Text", itemOrderNumber: 3, description: "", optionalDefaultValue: "",
                title: i18next.t('Tab4.Surname'), width_percentage: "Extra small", placeholder: "", label: 'Tab4.Surname'
            },
            maybe_answers: [],
            maybe_labels: [],
            user_input: undefined
        }
        return fieldSurname
    }
    let f3 = fieldSurname()

    let fieldJobFunction = () => {
        let fieldId: number = 14
        let fieldJobFunction: FieldData = {
            field: {
                Id: fieldId, CreatedDate: moment(), Kind: "Text", itemOrderNumber: 4, description: "", optionalDefaultValue: "",
                title: i18next.t('Tab4.Job_Function'), width_percentage: "Small", placeholder: "", label: 'Tab4.Job_Function'
            },
            maybe_answers: [],
            maybe_labels: [],
            user_input: undefined
        }
        return fieldJobFunction
    }
    let f4 = fieldJobFunction()

    let fieldOrganization = () => {
        let fieldId: number = 15
        let fieldOrganization: FieldData = {
            field: {
                Id: fieldId, CreatedDate: moment(), Kind: "Text", itemOrderNumber: 5, description: "", optionalDefaultValue: "",
                title: i18next.t('Tab4.Organization'), width_percentage: "Small", placeholder: "", label: 'Tab4.Organization'
            },
            maybe_answers: [],
            maybe_labels: [],
            user_input: undefined
        }
        return fieldOrganization
    }
    let f5 = fieldOrganization()

    let fieldPhone = () => {
        let fieldId: number = 16
        let fieldPhone: FieldData = {
            field: {
                Id: fieldId, CreatedDate: moment(), Kind: "Text", itemOrderNumber: 6, description: "", optionalDefaultValue: "",
                title: i18next.t('Tab4.Phone'), width_percentage: "Small", placeholder: "", label: 'Tab4.Phone'
            },
            maybe_answers: [],
            maybe_labels: [],
            user_input: undefined
        }
        return fieldPhone
    }
    let f6 = fieldPhone()

    let fieldEmail = () => {
        let fieldId: number = 17
        let fieldEmail: FieldData = {
            field: {
                Id: fieldId, CreatedDate: moment(), Kind: "UserEmail", itemOrderNumber: 7, description: "", optionalDefaultValue: "",
                title: i18next.t('Tab4.Email'), width_percentage: "Small", placeholder: "", label: 'Tab4.Email'
            },
            maybe_answers: [],
            maybe_labels: [],
            user_input: undefined
        }
        return fieldEmail
    }
    let f7 = fieldEmail()

    let field_list: FieldData[] = [f1, f2, f3, f4, f5, f6, f7]

    let mk_dependency_filled = () => {
        let dependencyId: number = 5
        let dependency_filled_data: DependencyData = {
            is_met: false,
            dependency: { CreatedDate: moment(), Id: dependencyId, Kind: "Filled", hideIfViolated: false, title: i18next.t('form.dep_filled'), lockSubmissionIfViolated: true },
            dependent_fields: [
                { FieldId: f1.field.Id },
                { FieldId: f3.field.Id },
                { FieldId: f4.field.Id },
                { FieldId: f5.field.Id },
                { FieldId: f6.field.Id },
                { FieldId: f7.field.Id }]
        }
        return dependency_filled_data
    }

    let mk_dependency_email = () => {
        let dependencyId: number = 6
        let dependency_email_data: DependencyData = {
            is_met: false,
            dependency: { CreatedDate: moment(), Id: dependencyId, Kind: "IsEmail", hideIfViolated: false, title: i18next.t('form.dep_email'), lockSubmissionIfViolated: true },
            dependent_fields: [{ FieldId: f7.field.Id }]
        }
        return dependency_email_data
    }
    let mk_dependency_phone = () => {
        let dependencyId: number = 7
        let dependency_phone_data: DependencyData = {
            is_met: false,
            dependency: { CreatedDate: moment(), Id: dependencyId, Kind: "IsPhoneNumber", hideIfViolated: false, title: i18next.t('form.dep_phone'), lockSubmissionIfViolated: true },
            dependent_fields: [{ FieldId: f6.field.Id }]
        }
        return dependency_phone_data
    }

    let dependency_filled = mk_dependency_filled()
    let dependency_email = mk_dependency_email()
    let dependency_phone = mk_dependency_phone()

    let dependency_list: DependencyData[] = [dependency_filled, dependency_email, dependency_phone]

    let step_4 = (): StepData => {

        return {
            dependencies: dependency_list,
            fields: field_list,
            step: { Id: 4, CreatedDate: moment(), orderNumber: 4, title: i18next.t('Tab4.Title') },
        }
    }

    return [step_4()]
}